import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { notification } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { UserContext } from "../../App";

const ApiKeyNotifier = () => {
  const { userApiKeyStatus } = useContext(UserContext);
  const location = useLocation();

  useEffect(() => {
    if (
      userApiKeyStatus &&
      location.pathname !== "/login" &&
      userApiKeyStatus.status !== "valid" &&
      userApiKeyStatus.status
    ) {
      let config = {
        key: "api-key-status",
        placement: "topRight",
        duration: 5,
      };

      if (userApiKeyStatus.status === "valid") {
        notification.success({
          ...config,
          message: "API Key Valid",
          description: userApiKeyStatus.message,
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
        });
      } else if (userApiKeyStatus.status === "invalid") {
        notification.error({
          ...config,
          message: "API Key Invalid",
          description: userApiKeyStatus.message,
          icon: <CloseCircleOutlined style={{ color: "red" }} />,
        });
      } else {
        notification.warning({
          ...config,
          message: "API Key Ambiguous",
          description: userApiKeyStatus.message,
          icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
        });
      }
    }
  }, [location, userApiKeyStatus]);

  return null;
};

export default ApiKeyNotifier;
